import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useAppDispatch } from 'client/hooks/use-dispatch'
import { getSettingsEditing } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import { setSettingsEditing } from 'client/store/management/managementActions'
import React, { ReactNode } from 'react'
import { BaseSubentity } from 'src/editor/layout/base-subentity'
import {
  FormInterface,
  FormSubentityInterface,
  FormSubentityTypeEnum,
} from 'src/shared/types/entities/form-interface'

export type FormBaseSubentityProps = {
  formEntity: FormInterface
  subentity: FormSubentityInterface
  title: string
  children?: ReactNode
}

export const FormBaseSubentity = ({
  formEntity,
  subentity,
  title,
  children,
}: FormBaseSubentityProps) => {
  const dispatch = useAppDispatch()

  const isEditing =
    useManagement(getSettingsEditing).subentityId === subentity.id

  const updateEntity = useUpdateEntity<FormInterface>()

  const onEdit = () => {
    dispatch(
      setSettingsEditing({
        id: formEntity.id,
        type: formEntity.type,
        subentityId: subentity.id,
      }),
    )
  }
  const onRemove = () => {
    updateEntity({
      ...formEntity,
      subEntities: formEntity.subEntities.filter(s => s.id !== subentity.id),
    })
  }
  return (
    <BaseSubentity
      subentity={subentity}
      isEditing={isEditing}
      flex
      flexColumn
      title={title}
      isRemoveAllowed={subentity.type !== FormSubentityTypeEnum.SubmitButton}
      onEdit={onEdit}
      onRemove={onRemove}
    >
      {children}
    </BaseSubentity>
  )
}
